/**
 *
 * Asynchronously loads the component for ItemOverview
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ItemOverview = lazyLoad(
  () => import('./index'),
  module => module.ItemOverview,
);
